var _a, _b, _c, _d, _e;
import { __decorate, __metadata, __param } from "tslib";
import { UserRepository } from '../repositories/user-repository.interface';
import { UserInfoService } from './user-info-service.interface';
import { UserSettingService } from './user-setting-service.interface';
import { UserCapacityService } from './user-capacity-service.interface';
import { UserPermissionService } from './user-permission-service.interface';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
let UserServiceImpl = class UserServiceImpl {
    constructor(_userInfoService, _userSettingService, _userCapacityService, _userPermissionService, _userRepository) {
        this._userInfoService = _userInfoService;
        this._userSettingService = _userSettingService;
        this._userCapacityService = _userCapacityService;
        this._userPermissionService = _userPermissionService;
        this._userRepository = _userRepository;
    }
    get userInfo() {
        return this._userInfoService.userInfo;
    }
    get userSetting() {
        return this._userSettingService.userSetting;
    }
    get userCapacity() {
        return this._userCapacityService.userCapacity;
    }
    get userPermission() {
        return this._userPermissionService.userPermission;
    }
    async initUser() {
        return this._userRepository.getUserInitData().then((data) => {
            this._userInfoService.updateUserInfo(data.user_info);
            this._userSettingService.updateUserSetting(data.user_setting);
            this._userCapacityService.updateUserCapacity(data.user_capacity);
            this._userPermissionService.updateUserPermission(data.user_permission);
            return data;
        });
    }
};
UserServiceImpl = __decorate([
    injectable(),
    __param(0, inject(UserInfoService)),
    __param(1, inject(UserSettingService)),
    __param(2, inject(UserCapacityService)),
    __param(3, inject(UserPermissionService)),
    __param(4, inject(UserRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserInfoService !== "undefined" && UserInfoService) === "function" ? _a : Object, typeof (_b = typeof UserSettingService !== "undefined" && UserSettingService) === "function" ? _b : Object, typeof (_c = typeof UserCapacityService !== "undefined" && UserCapacityService) === "function" ? _c : Object, typeof (_d = typeof UserPermissionService !== "undefined" && UserPermissionService) === "function" ? _d : Object, typeof (_e = typeof UserRepository !== "undefined" && UserRepository) === "function" ? _e : Object])
], UserServiceImpl);
export { UserServiceImpl };
